<button
  type="button"
  class="chat-list-item w-full flex align-items-center gap-2 p-3 text-left border-none cursor-pointer"
  [class.chat-list-item--activo]="activo()"
  [class.chat-list-item--no-leido]="noLeido()"
  [attr.aria-current]="activo() ? 'true' : null"
  (click)="seleccionar.emit()"
>
  <p-avatar
    [label]="iniciales()"
    shape="circle"
    [style]="avatarStyle()"
    [image]="conversacion().img ?? undefined"
    [ariaLabel]="nombreCompleto()"
  />

  <span class="flex-1 min-w-0 flex flex-column gap-1">
    <span class="flex align-items-center justify-content-between gap-2">
      <span
        class="chat-list-item__nombre text-sm text-color white-space-nowrap overflow-hidden text-overflow-ellipsis"
      >
        {{ nombreCompleto() }}
        @if (mostrarNivel()) {
          <span class="text-xs text-color-secondary font-normal ml-1">{{ conversacion().nivelPersonal }}</span>
        }
      </span>
      @if (ultimoMensaje()) {
        <span class="flex-none text-xs text-color-secondary">{{ ultimoMensaje()!.fecha }}</span>
      }
    </span>

    <span class="flex align-items-center justify-content-between gap-2">
      <span
        class="text-xs text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis"
      >
        @if (perspectiva() === 'lider') {
          {{ ultimoMensaje()?.nota || 'Sin mensajes' }}
        } @else {
          L&iacute;der: {{ liderLabel() }}
        }
      </span>

      <span class="flex-none flex align-items-center gap-2">
        @if (cumpleProximo()) {
          <i
            class="pi pi-gift text-sm chat-list-item__torta"
            pTooltip="Cumplea&ntilde;os cerca"
            tooltipPosition="top"
            aria-hidden="true"
          ></i>
        }
        @if (tienePendiente()) {
          <i
            class="pi pi-exclamation-triangle text-sm chat-list-item__alerta"
            pTooltip="Solicitud pendiente"
            tooltipPosition="top"
            aria-hidden="true"
          ></i>
        }
        @if (faltaDato()) {
          <i
            class="pi pi-question-circle text-sm chat-list-item__pregunta"
            pTooltip="Faltan datos"
            tooltipPosition="top"
            aria-hidden="true"
          ></i>
        }
      </span>
    </span>
  </span>
</button>
